import { defineProductDimensions, esRcphPricingVersionDimension, esRcphSelectedDimension } from '@orus.eu/dimensions'

import { esRcphProductVersionDimension } from './es-rcph-product-version-dimension.ts'
import { esRcphQuoteDimension, esRcphQuoteV3Dimension } from './es-rcph-quote-dimension.ts'

export * from './es-rcph-dimensions.ts'
export * from './es-rcph-product-vocabulary.ts'
export * from './es-rcph-subscription-ui.ts'

export const esRcphDimensionsModule = defineProductDimensions({
  product: 'es-rcph',
  family: null,
  selectionDimension: esRcphSelectedDimension,
  productVersionDimension: esRcphProductVersionDimension,
  pricingVersionDimension: esRcphPricingVersionDimension,
  quoteV2Dimension: esRcphQuoteDimension,
  quoteV3Dimension: esRcphQuoteV3Dimension,
})
